import { BaseMapper } from '@ps/utils';

import { CurrencySettingsDto } from '../dtos/currency-settings.dto';
import { CurrencySettings } from '../../models/currency-settings.model';

export class CurrencySettingsMapper extends BaseMapper<
  CurrencySettingsDto,
  CurrencySettings
> {
  public fromDto(dto: CurrencySettingsDto): CurrencySettings {
    return {
      crRate: dto.CRRate,
      name: dto.currencyFullName,
      code: dto.currencyShortCode,
      fx: dto.fx,
      rate: dto.rate,
      symbol: dto.symbol,
    };
  }
}
